import styled from "styled-components";

import type { ChangeRate } from "types/BusinessDashboard";
import { ChangeIndicator } from "./change-indicator";

const StyledCard = styled.div<{ bgColor: string }>`
  border-radius: 16px;
  border: none;
  box-shadow: none;
  padding: 0;
  background-color: ${({ bgColor }) => bgColor};
`;

const StyledCardContent = styled.div`
  padding: 12px 16px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
`;

const Title = styled.p<{ color: string }>`
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: -0.2px;
  color: ${({ color }) => color};
  margin: 0;
  margin-bottom: 6px;
`;

const ValueRow = styled.div`
  display: flex;
  align-items: center;
`;

const Value = styled.span`
  font-size: 18px;
  font-weight: bold;
  line-height: 28px;
  letter-spacing: -0.4px;
  color: #202020;
`;

const PercentageValue = styled.span<{ color: string }>`
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.2px;
  color: ${({ color }) => color};
  margin-left: 4px;
`;

const InfoColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

const CustomChangeIndicator = styled(ChangeIndicator)`
  justify-content: flex-start !important;
`;

interface MembersBreakdownCardProps {
  title: string;
  value: number;
  changeRate: ChangeRate;
  color: string;
  bgColor: string;
  percentage: number;
}

export const MembersBreakdownCard = ({
  title,
  value,
  changeRate,
  color,
  bgColor,
  percentage,
}: MembersBreakdownCardProps) => {
  return (
    <StyledCard bgColor={bgColor}>
      <StyledCardContent>
        <InfoColumn>
          <Title color={color}>{title}</Title>
          <ValueRow>
            <Value>{value.toLocaleString()}명</Value>
            <PercentageValue color={color}>{percentage}%</PercentageValue>
          </ValueRow>
          <CustomChangeIndicator showIcon changeRate={changeRate} />
        </InfoColumn>
      </StyledCardContent>
    </StyledCard>
  );
};
